import React from "react";

const Loading = () => <div className="App-auth-message">Loading...</div>

export default Loading
